export const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const phonePattern = /^(?:\+1\s?)?(\(\d{3}\)|\d{3})[-.\s]?(\d{3})[-.\s]?(\d{4})$/gi;
export const zipCodePattern = /^\d{5}$/gm;
export const ssnPattern = /^(?:\d{4}|\d{9}|\d{3}-\d{2}-\d{4})$/;
export const datePattern = /^(0?[1-9]|1[0-2])[-\/](0?[1-9]|[12][0-9]|3[01])[-\/](\d{4})$/;

